import { Page } from "containers/Page";
import { TabsStyled } from "features/Login/components/LoginBox/style";
import { useState } from "react";
import { Tab } from "react-bootstrap";
import { TIPO_SOLICITACAO_PLACA } from "../SolicitacaoPlaca/constants/tipoSolicitacaoPlaca";
import { useTotalPendentes } from "../SolicitacaoPlaca/hooks/useTotalPendentes";
import { LotesGerados } from "./containers/LotesGerados";
import { Solicitacoes } from "./containers/Solicitacoes";

const ABA_SOLICITACOES = "solicitacoes";
const ABA_LOTES = "lotes";

export function PlacaTerceiros() {
  const tipo = TIPO_SOLICITACAO_PLACA.TERCEIROS;
  const [aba, setAba] = useState(ABA_SOLICITACOES);
  const {
    total: totalSolicitacoes,
    recarregarTotal: recarregarTotalSolicitacoes,
  } = useTotalPendentes(tipo);

  function selecionarAba(chave: string | null) {
    setAba(chave as string);
    if (chave === ABA_SOLICITACOES) recarregarTotalSolicitacoes();
  }

  return (
    <Page lastPage="Home / BackOffice" title="Placa terceiros">
      <TabsStyled
        host=""
        id="tabs-placa-terceiros"
        className="mt-4"
        activeKey={aba}
        onSelect={selecionarAba}
      >
        <Tab
          eventKey={ABA_SOLICITACOES}
          title={`Solicitações (${totalSolicitacoes})`}
        >
          <Solicitacoes
            ativa={aba === ABA_SOLICITACOES}
            onLoteEnviado={recarregarTotalSolicitacoes}
          />
        </Tab>
        <Tab eventKey={ABA_LOTES} title="Lotes gerados">
          <LotesGerados
            ativa={aba === ABA_LOTES}
            onLoteRemovido={recarregarTotalSolicitacoes}
          />
        </Tab>
      </TabsStyled>
    </Page>
  );
}
